import styles from './Note.module.css'

const Note = ({
  note,
  toggleImportance,
  handleRemove,
  user,
}) => {
  return (
    <div className={`${styles.root}`}>
      <span
        className={styles.action}
        onClick={toggleImportance}
      >
        {note.important ? '⭐' : '⬆️'}
      </span>

      <p className={styles.content}>{note.content}</p>

      {user ? (
        <span
          className={styles.action}
          onClick={handleRemove}
        >
          ❌
        </span>
      ) : null}
    </div>
  )
}

export default Note
